import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import byProductsIcon from "../../../../../assets/new-product-detail-cats/sub-icons/surplus-material-flows.svg";
import ProdByProductsTable from "./Table";
import "./index.css";

const ProdByProductsContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });

  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-manufacturing-contents">
      <SubHeaderBox
        subTitle={t("BY_PRODUCTS_MANUFACTURING_PROCESS") || "By-products that arise from the manufacturing process"}
        subDescription={
          t("BY_PRODUCTS_MANUFACTURING_PROCESS_DESC") ||
          "Enter any surplus material that can be used as products in their own right or refined further into products."
        }
        isNormal={true}
        number={"33.2"}
        showSystemBoundary={false}
        icon={byProductsIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-byproducts-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdByProductsTable productId={productId} />
        </TableLoadingWrapper>
      )}

      {!isPDFMode && (
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      )}
    </div>
  );
};

export default ProdByProductsContents;












